export default __webpack_public_path__ + "static/media/MadeUp.2bec5b23.png";